import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { RECRUITER_KEYS } from "./keys";
import toFormData from "./toFormData";

/**
 * Save the authenticated recruiter's settings.
 *
 * POST rather than PATCH because the payload can carry a terms_document upload,
 * and PHP only parses multipart bodies on POST. The endpoint is scoped to the
 * authenticated user, so unlike useMutateRecruiter there is no id in the URL.
 */
export default function useMutateRecruiterSettings() {
  const api = useAxios();
  const client = useQueryClient();

  return {
    mutation: useMutation({
      mutationFn: (settings: Record<string, unknown>) =>
        api.post("/me/settings", toFormData(settings), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
      onSuccess: () => {
        // Only the settings key. Invalidating the recruiter key as well would
        // settle two refetches, and the Settings dialog only absorbs one.
        client.invalidateQueries({ queryKey: RECRUITER_KEYS.settings() });
      },
    }),
    clearQuery: () =>
      client.invalidateQueries({ queryKey: RECRUITER_KEYS.settings() }),
  };
}
